import { jsxs as s, jsx as n } from "react/jsx-runtime";
import { useMultiStyleConfig as t, chakra as e, Spinner as a } from "@chakra-ui/react";
const p = ({
  loadingText: i = "Uploading file, hold on a moment..."
}) => {
  const { heading: o, spinnerContainer: r } = t("FileUploader");
  return /* @__PURE__ */ s(e.div, { __css: r, children: [
    /* @__PURE__ */ n(a, { speed: "1s" }),
    /* @__PURE__ */ n(e.span, { __css: o, children: i })
  ] });
};
export {
  p as Loading
};
//# sourceMappingURL=Loading.es.js.map
